import React from 'react';
import { BoxSelection, Image, ImageResizeOptions, Text } from 'wix-ui-tpa/cssVars';
import { Image as ImageIcon } from '@wix/wix-ui-icons-common';
import { useConfig } from '../../../contexts/config-context';
import { generateUUID } from '@wix/form-schema';
import { classes, st } from './media-box-selection.st.css';
export const MediaBoxSelection = _ref => {
  let {
    className = '',
    dataHook = '',
    label = '',
    alignment = 'left',
    fit = 'cover',
    isMultipleAnswers,
    columns,
    options
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const [selected, setSelected] = React.useState({});
  const onSelectionChange = React.useCallback(_ref2 => {
    let {
      id
    } = _ref2;
    if (selected[id]) {
      setSelected({
        ...selected,
        [id]: false
      });
    } else {
      if (isMultipleAnswers) {
        setSelected({
          ...selected,
          [id]: true
        });
      } else {
        setSelected({
          [id]: true
        });
      }
    }
  }, [selected, isMultipleAnswers]);
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root, {
      mobile: isMobile,
      alignment,
      fit,
      columns
    }, className),
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(BoxSelection, {
    name: `media-box-selection-${generateUUID()}`,
    label: label,
    onChange: onSelectionChange
  }, options.map(option => {
    var _option$media, _option$media2;
    const image = (_option$media = option.media) == null ? void 0 : _option$media.image;
    const aspectRatio = image ? image.width / image.height : 1;
    return /*#__PURE__*/React.createElement(BoxSelection.Option, {
      id: option.id,
      className: classes.option,
      checked: selected[option.id]
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.optionMediaContent
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.imgWrapper
    }, image ? /*#__PURE__*/React.createElement(Image, {
      className: classes.img
      // src={getMediaImagePreview(image, 500, 500)} // todo: 124 (dimensions)
      ,
      src: (_option$media2 = option.media) == null || (_option$media2 = _option$media2.image) == null ? void 0 : _option$media2.id,
      alt: (image == null ? void 0 : image.altText) || '',
      aspectRatio: aspectRatio,
      sourceWidth: (image == null ? void 0 : image.width) || 100,
      sourceHeight: (image == null ? void 0 : image.height) || 100,
      stretchImage: false,
      resize: fit === 'cover' ? ImageResizeOptions.cover : ImageResizeOptions.contain
    }) : /*#__PURE__*/React.createElement("div", {
      className: classes.blankImgWrapper
    }, /*#__PURE__*/React.createElement(ImageIcon, {
      className: classes.blankImg
    }))), option.label && !option.isLabelHidden ? /*#__PURE__*/React.createElement(Text, {
      className: classes.optionLabel
    }, option.label) : null));
  }))));
};
//# sourceMappingURL=media-box-selection.js.map